import { useTranslation } from 'react-i18next';

import { i18nNS } from '../../../i18n';
import BarChartIcon from '../../../icons/BarChartIcon';
import ActivityWidget from '../../../components/ActivityWidget';
import { Poll } from '../../../db/polls/types';

interface Props {
  id?: string;
  className?: string;
  onClick?: React.MouseEventHandler;
  tabIndex?: number;
  poll: Poll;
}

const PollCard = ({ id: rootId, poll, className, onClick, tabIndex }: Props) => {
  const { t } = useTranslation([i18nNS.GLOSSARY]);

  return (
    <ActivityWidget
      id={rootId}
      className={className}
      icon={<BarChartIcon size={28} />}
      variant="primary"
      title={poll.title}
      unseenComments={true}
      description={poll.title || t('untitled', { ns: i18nNS.GLOSSARY })}
      tabIndex={tabIndex}
    />
  );
};

export default PollCard;
